<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header
    titleIcon="billing"
    title="LLM Pricing"
    subtitle="The price list every LLM call is costed against. Prices are USD per MILLION tokens — the unit providers publish."
  />

  <div class="panel">
    <div class="mb-4 flex items-center justify-between gap-4">
      <div class="text-sm text-white-dark">
        Each model may have one current price. To change it, use Edit; to replace it entirely, delete the row and add a new one.
        Historical rows from earlier versions remain read-only.
      </div>
      <button type="button" [class]="btn.primary" (click)="openForm()" [disabled]="!modelsAvailableForAdd.length">
        Add price
      </button>
    </div>

    @if (error) {
    <div class="mb-4 rounded border border-danger/40 bg-danger-light p-3 text-danger">{{ error }}</div>
    } @if (showForm) {
    <div class="mb-4 rounded border border-white-light p-4 dark:border-[#1b2e4b]">
      <h3 class="mb-3 text-sm font-semibold">{{ editingId ? 'Edit price' : 'Add price' }}</h3>
      <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
        @if (editingId) {
        <div class="block">
          <span class="text-xs text-white-dark">Model</span>
          <div class="form-input mt-1 bg-gray-50 dark:bg-[#0e1726]">{{ modelLabel(form.model_id!) }}</div>
        </div>
        } @else {
        <label class="block">
          <span class="text-xs text-white-dark">Model</span>
          <select class="form-select mt-1" [(ngModel)]="form.model_id">
            <option [ngValue]="null">Select a model…</option>
            @for (model of modelsAvailableForAdd; track model.id) {
            <option [ngValue]="model.id">{{ model.label }}</option>
            }
          </select>
        </label>
        }
        <label class="block">
          <span class="text-xs text-white-dark">Input price / 1M tokens (USD)</span>
          <input type="text" class="form-input mt-1" placeholder="0.15" [(ngModel)]="form.input_price_per_1m" />
        </label>
        <label class="block">
          <span class="text-xs text-white-dark">Output price / 1M tokens (USD)</span>
          <input type="text" class="form-input mt-1" placeholder="0.60" [(ngModel)]="form.output_price_per_1m" />
        </label>
        <label class="block">
          <span class="text-xs text-white-dark">Cached input / 1M (optional)</span>
          <input type="text" class="form-input mt-1" placeholder="0.075" [(ngModel)]="form.cached_input_price_per_1m" />
        </label>
        @if (!editingId) {
        <label class="block">
          <span class="text-xs text-white-dark">Effective from</span>
          <input type="date" class="form-input mt-1" [(ngModel)]="form.effective_from" />
        </label>
        }
        <label class="block">
          <span class="text-xs text-white-dark">Notes</span>
          <input type="text" class="form-input mt-1" [(ngModel)]="form.notes" />
        </label>
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <button type="button" [class]="btn.secondary" (click)="closeForm()">Cancel</button>
        <button type="button" [class]="btn.primary" (click)="save()" [disabled]="saving">
          {{ saving ? 'Saving…' : (editingId ? 'Update price' : 'Save price') }}
        </button>
      </div>
    </div>
    } @if (loading) {
    <div class="py-10 text-center text-white-dark">Loading…</div>
    } @else {
    <div class="table-responsive">
      <table class="table-hover">
        <thead>
          <tr>
            <th>Model</th><th class="text-right">Input / 1M</th><th class="text-right">Output / 1M</th>
            <th class="text-right">Cached / 1M</th><th>Effective from</th><th>Effective to</th><th>Notes</th><th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.id) {
          <tr [class.opacity-60]="!isCurrent(row)">
            <td>
              {{ row.model?.display_name || row.model_id }}
              @if (isCurrent(row)) {
              <span class="ml-1 badge bg-success-light text-success">current</span>
              }
            </td>
            <td class="text-right">{{ row.currency }} {{ row.input_price_per_1m }}</td>
            <td class="text-right">{{ row.currency }} {{ row.output_price_per_1m }}</td>
            <td class="text-right">{{ row.cached_input_price_per_1m || '—' }}</td>
            <td>{{ row.effective_from | date : 'dd MMM yyyy' }}</td>
            <td>{{ row.effective_to ? (row.effective_to | date : 'dd MMM yyyy') : '—' }}</td>
            <td class="text-xs text-white-dark">{{ row.notes }}</td>
            <td class="text-right whitespace-nowrap">
              @if (isCurrent(row)) {
              <button type="button" [class]="btn.smallSecondary + ' mr-2'" (click)="openEdit(row)">Edit</button>
              <button
                type="button"
                [class]="btn.smallSecondary"
                (click)="deleteRow(row)"
                [disabled]="deletingId === row.id"
              >
                {{ deletingId === row.id ? 'Deleting…' : 'Delete' }}
              </button>
              } @else {
              <span class="text-xs text-white-dark">—</span>
              }
            </td>
          </tr>
          } @empty {
          <tr><td colspan="8" class="py-8 text-center text-white-dark">No prices yet — calls will record tokens but no cost.</td></tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
</div>
